export default [{
  path: '/',
  redirect: '/login',
},
{
  path: '/login',
  name: 'login',
  meta: {
    "name": 'login',
    "title": '数据资源管理平台',
    hideInMenu: true
  },
  component: () => import('./../views/login/login'),

},
{
  path: '/home',
  name: 'home',
  meta: {
    "name": 'home',
    "title": '首页',
  },
  component: () => import('./../views/home/home.vue'),
},
{
  path: '/home2',
  name: 'home2',
  meta: {
    "name": 'home2',
    "title": '首页2',
  },
  component: () => import('./../views/home/myTask.vue'),
},
{
  path: '/ceshi',
  name: 'ceshi',
  meta: {
    "name": 'ceshi',
    "title": '测试',
  },
  component: () => import('./../views/home/home.vue'),
},
{
  path: '/serviceList',
  name: 'serviceList',
  meta: {
    "name": 'serviceList',
    "title": '事项列表',
  },
  component: () => import('./../views/home/serviceList.vue'),
},
// {
//   path: '/perpson',
//   name: 'perpson',
//   meta: {
//     "name": 'perpson',
//     "title": '个人信息',
//   },
//   component: () => import('./../views/home/perpson.vue'),
// },

{
  path: '/searchList',
  name: 'searchList',
  meta: {
    "name": 'searchList',
    "title": '搜索结果',
  },
  component: () => import('./../views/search/searchList.vue'),
},
{
  path: '/noticeList',
  name: 'noticeList',
  meta: {
    "name": 'noticeList',
    "title": '通知公告',
  },
  component: () => import('./../views/search/noticeList.vue'),
},
{
  path: '/noticeDetail',
  name: 'noticeDetail',
  meta: {
    "name": 'noticeDetail',
    "title": '通知公告详情',
  },
  component: () => import('./../views/search/noticeDetail.vue'),
},
// {
//   path: '/editPhone',
//   name: 'editPhone',
//   meta: {
//     "name": 'editPhone',
//     "title": '修改手机号',
//   },
//   component: () => import('./../views/editPhone/editPhone.vue'),
// },
{
  path: '/authenticationForm',
  name: 'authenticationForm',
  meta: {
    "name": 'authenticationForm',
    "title": '二次登录',
  },
  // component: () => import('./../views/login/authenticationForm.vue'),
  component: () => import('../views/secondAuth/secondAuth.vue'),
},
// {
//   path: '/editPass',
//   name: 'editPass',
//   meta: {
//     "name": 'editPass',
//     "title": '修改密码',
//   },
//   component: () => import('./../views/editPass/editPass.vue'),
// },
{
  path: '/help/:file',
  name: 'help',
  meta: {
    "name": 'help',
    "title": '帮助中心',
    requireAuth: false,
  },
  component: () => import('../views/help/help.vue'),
},
{
  path: '/loginout',
  name: 'loginout',
  meta: {
    "name": 'loginout',
    "title": '退出登录',
  },
  component: () => import('./../views/login/loginout.vue'),
},
{
  path: '/authority',
  name: 'authority',
  meta: {
    "name": 'authority',
    "title": '暂无权限',
  },
  component: () => import('./../views/login/authority.vue'),
},
]